// Global error messages for use across the application
export enum LoanErrorMessage {
  LOAN_NOT_FOUND = 'Loan not found',
  PAYMENT_HISTORY_NOT_FOUND = 'Payment history not found',
  LOAN_STATEMENTS_NOT_FOUND = 'Loan statements not found',
  RECURRING_PAYMENT_NOT_FOUND = 'Recurring payment not found',
  INVALID_ROUTING_NUMBER_FORMAT = 'Invalid routing number format. Must be 9 digits.',
  BANK_NOT_FOUND = 'Bank not found for the provided routing number.',
  FILE_NOT_FOUND = 'File not found',
}
